import { render, staticRenderFns } from "./MyCafeMenu.vue?vue&type=template&id=2d039379"
import script from "./MyCafeMenu.vue?vue&type=script&lang=js"
export * from "./MyCafeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports